import { DataFilter } from '@siclop/kstone-vue'

export class EmployeeScheduleFilter extends DataFilter {
  employeeId?: number
  workScheduleTemplateId?: number

  constructor(data?: Partial<EmployeeScheduleFilter>) {
    super(data)
    if (data) {
      this.employeeId = data.employeeId
      this.workScheduleTemplateId = data.workScheduleTemplateId
    }
  }
}
